import { ClientMessageHeader } from "../../models/client-message";
import { User } from "../../models/user"

export namespace Messages 
{

    export class UserLoggedIn
    {
        static readonly type = "[Messages Login Action] Successful Login";
        constructor(public payload: { user: User }) {}
    }

    export class InitialMessagesLoaded
    {
        static readonly type = "[Messages Action] Messages Loaded";
    }

    export class MessageDeliveryConfirmed
    {
        static readonly type = "[Message Service] Message Delivery Confirmed";
        constructor(public payload: { message: ClientMessageHeader }) {}
    }

    export class NewMessageReceived
    {
        static readonly type = "[Message Service] New Message Received";
        constructor(public payload: { message: ClientMessageHeader }) {}
    }

    export class UnreadMessagesShown
    {
        static readonly type = "[Message Viewer] Unread Messages Shown";
        constructor(public payload: { message: ClientMessageHeader }) {}
    }

    export class MessageRead
    {
        static readonly type = "[Message Viewer] Message Read";
        constructor(public payload: { message: ClientMessageHeader }) {}
    }

    export class MessageUnread
    {
        static readonly type = "[Message Viewer] Message Unread";
        constructor(public payload: { message: ClientMessageHeader }) {}
    }

    
}